export class Socket {
  constructor($rootScope) {
    let socket = io.connect(':3001', {
      secure: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax : 15000,
      reconnectionAttempts: 99999
    });

    return {
      on: function (eventName, callback) {
        socket.on(eventName, function () {
          let args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          });
        });
      },

      emit: function (eventName, data, callback) {
        socket.emit(eventName, data, function () {
          let args = arguments;
          $rootScope.$apply(function () {
            if (callback) {
              callback.apply(socket, args);
            }
          });
        })
      },

      isConnected: function() {
        return socket.connected;
      }
    }
  }
}
